export const MarketplaceIds = {
  ShipStation: 0,
  EBay: 1,
  Amazon: 2,
  Rakuten: 3,
  PayPal: 6,
  Volusion: 7,
  Etsy: 8,
  GoogleCheckout: 9,
  ZenCart: 10,
  Payvment: 11,
  MagentoGo: 12,
  BigCommerce: 13,
  Shopify: 14,
  AmazonUK: 15,
  OsCommerce: 16,
  XCart: 17,
  ChannelAdvisor: 18,
  OpenCart: 19,
  Memberly: 20,
  Spree: 21,
  CustomStore: 22,
  ThreeDcart: 23,
  Yahoo: 24,
  Sears: 25,
  StitchLabs: 26,
  TopShelf: 27,
  Magento: 28,
  Bizelo: 29,
  LemonStand: 30,
  Highwire: 31,
  AmazonCA: 32,
  Goodsie: 33,
  NewEgg: 34,
  UltraCart: 35,
  WooCommerce: 36,
  CommerceInterface: 37,
  AbanteCart: 38,
  Sophio: 39,
  Storenvy: 40,
  Brightpearl: 41,
  AmazonDE: 42,
  AmazonES: 43,
  AmazonFR: 44,
  AmazonIT: 45,
  EcwidV1: 46,
  Redditgifts: 47,
  Wish: 48,
  Soldsie: 49,
  BestBuy: 50,
  PrestaShop: 51,
  EBayUK: 52,
  EBayCA: 53,
  MivaMerchant: 54,
  Jane: 55,
  Vault: 56,
  Squarespace: 57,
  Bigcommerce: 58,
  AmeriCommerce: 59,
  SkuVault: 60,
  FoxyCart: 61,
  CSCart: 62,
  Bonanza: 63,
  MijoShop: 64,
  SellerActive: 65,
  MoreCommerce: 66,
  TradeGecko: 67,
  GrouponGoods: 68,
  Reverb: 69,
  Square: 70,
  Choxi: 71,
  AmazonJP: 72,
  NeweggBusiness: 73,
  WooCommerceV2: 74,
  FullscreenDirect: 75,
  Celery: 76,
  Penny: 77,
  Groopdealz: 78,
  CrateJoy: 79,
  DearSystems: 80,
  Freestyle: 81,
  SellBrite: 82,
  Hatch: 83,
  Zoey: 84,
  Linnworks: 85,
  BigCartel: 86,
  AmazonMX: 87,
  SureDone: 88,
  SecureStore: 89,
  NeweggCanada: 90,
  Spreesy: 91,
  Ecwid: 92,
  Walmart: 93,
  Mozu: 94,
  Stripe: 95,
  Tanga: 96,
  Weebly: 97,
  LabelApi: 98,
  EBayAU: 99,
  Houzz: 100,
  Tophatter: 101,
  ODBC: 102,
  SparkShipping: 103,
  ChannelSale: 104,
  CoreCommerce: 105,
  GeekSeller: 106,
  SAPAnywhere: 107,
  Cin7: 108,
  Bandcamp: 109,
  Jet: 110,
  SalesforceCommerceCloud: 111,
  RevolutionParts: 112,
  AmazonAU: 113,
  Handshake: 114,
  Acumatica: 115,
  Facebook: 116,
  ShipEngineApi: 118,
  Wix: 119,
  Overstock: 120,
  ListingMirror: 123,
  Ordertime: 128,
  Volo: 129,
  InkSoft: 130,
  MiraklBestBuyCA: 131,
  AcumaticaV2: 132,
  VisualSoft: 133,
  WalmartCA: 134,
  SalesforceCore: 135,
  NotOnTheHighStreet: 136,
  CustomStore2: 138,
  CDiscount: 139,
  Alibaba: 140,
  EBayFR: 141,
  Oxatis: 142,
  EbayV2: 144,
  AuctaneFulfillment: 155,
  OAuthDummy: 161,
  MercadoLibre: 162,
  BigCommerceV3: 163,
  DummyMarketplace: 1000,
  TikTok: 4008,
};
